import Box from "@components/Box";
import AsideNew from "@components/CaseStudyComponents/AsideNew";
import TestimonialSectionCaseStudy from "@components/LandingPageComponents/TestimonialSectionCaseStudy";
import { AppButton } from "@components/Typography";
import "keen-slider/keen-slider.min.css";
import Image from "next/image";
import React, { FC } from "react";
import AchievementCard from "../../components/CaseStudyComponents/AchievementCard";
import RelatedCaseStudies from "../../components/CaseStudyComponents/RelatedCaseStudies";
import NewLayout from "../../components/new-ui/Layout";

const itees: FC = () => {
    const cardData = [
        {
            imgpath: "https://assets.gallabox.com/gb-home/itees/Vector1.png",
            title: "Increased employee productivity",
            count: "70%",
            borderColor: "#ACDAF1",
            boxShadowColor: "white",
            fontColor: "#4299E1",
            gradient: "linear-gradient(105.67deg, rgba(215, 235, 245, 0.2) 0%, #D7EBF5 95.66%)",
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/itees/Vector2.png",
            title: "Growth in Patient Footfall",
            count: "500%",
            borderColor: "#9AE6B4",
            boxShadowColor: "white",
            fontColor: "#38A169",
            gradient: "linear-gradient(285.78deg, #ECF8E1 3.17%, rgba(236, 248, 225, 0.2) 96.84%)",
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/itees/vector3.png",
            title: "Improved Return Visits",
            count: "54%",
            borderColor: "#DEBEF3",
            boxShadowColor: "white",
            fontColor: "#805AD5",
            gradient: "linear-gradient(285.94deg, #EFE1F8 1.79%, rgba(239, 225, 248, 0.2) 98.89%)",
        },
    ];
    const redBoxPoints = ["Legacy tools causing delays", "Too much reliance on manual effort", "Redundancy and repetitive tasks"];
    const greenBoxPoints = ["70% increase in employee productivity", "500% growth in patient footfall", "3x improvement in return visits"];
    const RELATED_CASE_STUDIES = [
        {
            id: 1,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-1.png",
            tag: "Travel & Tourism",
            title: "LivingStone Stays Relocated Their Communications From..",
            link: "/case-study/livingstone-stay",
            description:
                "Founded in 2019, LivingStone Stays is revolutionising the way people spend their leisure time - making holidays a way of life. Their platform is a one-stop ...",
        },
        {
            id: 2,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-3.png",
            tag: "HR & Professional Service",
            title: "Jobstars India Deployed a Multilingual Chatbot to Handle 60%..",
            link: "/case-study/jobstars-india",
            description:
                "Founded in 2002, Jobstars is one of the leading players in the Indian recruitment ecosystem. They believe in combining their passion for people with smart investments ...",
        },
    ];

    return (
        <NewLayout
            title="ITEES Eye Hospital | WhatsApp automation customer story"
            description="Learn how ITEES Eye Hospital built a thriving and satisfied customer base with personalised patient care through WhatsApp Automation with Gallabox"
            canonical="https://gallabox.com/case-study/itees"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/itees/og.png" }}
        >
            <header className="grid lg:pt-20 pt-0 pb-4 itees-header">
                <div className="hero-section h-full flex flex-col-reverse xl:flex-row px-4 xl:justify-between pt-12 lg:pt-0 mx-auto">
                    <div className="w-full h-full lg:w-1/2 lg:space-y-10 space-y-2 lg:pt-14 pt-10 order-1 lg:order-1 lg:overflow-hidden border-transparent">
                        <Image width={483} height={310} src="https://assets.gallabox.com/gb-home/itees/header.png" objectFit="scale-down" alt="itees-header-image" />
                    </div>
                    <div className="h-full w-full lg:w-1/2 order-2 lg:order-2 lg:space-y-6 space-y-2 lg:pt-20">
                        <h1 className="font-semibold text-3xl lg:text-4xl lg:leading-tight" style={{ color: "#293056" }}>
                            Improving Patient Experience at ITEES Eye Hospital: A Gallabox Success Story
                        </h1>
                        <div className="text-xl text-gray-600">
                            Learn how ITEES Eye Hospital built a thriving and satisfied customer base with personalised patient care through WhatsApp Automation with Gallabox.
                        </div>
                    </div>
                </div>
            </header>

            <div>
                <section className="max-w-6xl mx-auto flex flex-col items-center sm:flex-row gap-5 my-20 justify-between ">
                    {cardData.map((eachobj) => {
                        return (
                            <AchievementCard
                                key={""}
                                imagePath={eachobj.imgpath}
                                imageTitle={eachobj.title}
                                count={eachobj.count}
                                borderColor={eachobj.borderColor}
                                boxShadowColor={eachobj.boxShadowColor}
                                fontColor={eachobj.fontColor}
                                gradient={eachobj.gradient}
                            />
                        );
                    })}
                </section>
            </div>
            <div className=" mx-auto mt-20 lg:px-0 px-4">
                <div className="max-w-6xl mx-auto flex flex-col sm:flex-row gap-8">
                    <div className=" mx-auto lg:w-64  ">
                        <AsideNew
                            data={[
                                {
                                    title: "Company",
                                    content: "ITEES Eye Hospital",
                                },
                                {
                                    title: "Industry",
                                    content: "Healthcare",
                                },
                                {
                                    title: "Employees",
                                    content: "50-200",
                                },

                                {
                                    title: "Product Used",
                                    content: ["Odoo Integration ", "Automated AI Chatbots", "WhatsApp Broadcasts", "Target Segmentation"],
                                },
                                {
                                    title: "Chats per Month",
                                    content: "7k+",
                                },
                                {
                                    title: "website",
                                    link: "iteeseyehospital.com/",
                                    content: "iteeseyehospital.com",
                                },
                            ]}
                        />
                        <div className=" sm:sticky top-24 pt-4 pb-10">
                            <Box title="Pain Points 🥲" points={redBoxPoints} bgColor="red-50" textColor="red-600" />
                            <Box title="Results 🤩" points={greenBoxPoints} bgColor="green-50" textColor="green-600" />
                        </div>
                    </div>
                    <main className="  lg:px-8 px-4    ">
                        <div>
                            <h2 className="lg:text-5xl text-2xl  font-bold pb-8" style={{ color: "#4A5568" }}>
                                The Battle with Traditional Customer Support Methods
                            </h2>
                            <div className="">
                                <p className="lg:text-lg text-base text-gray-500 pb-6">
                                    Even with their medical proficiency, ITEES was wrestling with the administratively exhaustive and time-consuming task of customer support. Here
                                    are some common manual patient care management troubles that motivated them to look beyond the traditional means and manual effort:
                                </p>
                                <div>
                                    {" "}
                                    <h2 className="text-2xl text-gray-500 font-semibold pb-8">Manual Data Transfer: A Herculean Task</h2>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        A key obstacle in ITEES’s patient care management process was that their communication platforms were incompatible with their CRM software,
                                        Odoo.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        For data to move effectively across applications, the internal team had to perform the repetitive and unproductive task of manually
                                        transferring data from the CRM to these apps. Unavoidably, this further drained the staff&apos;s valuable time.
                                    </p>
                                </div>
                                <div>
                                    {" "}
                                    <h2 className="text-2xl text-gray-500 font-semibold pb-8">Time Drains in Communication Efforts</h2>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        These communication methods were not just ineffective; they were also costly and time-consuming. It required substantial manual effort to
                                        sell through these channels and offer customer support.Time is an incredibly precious commodity in the healthcare realm, and unproductive
                                        techniques for task execution can hurt both the organisation and patient satisfaction.
                                    </p>
                                </div>
                                <div>
                                    {" "}
                                    <h2 className="text-2xl text-gray-500 font-semibold pb-8">Information Overload and Repetition</h2>
                                    <p className="lg:text-lg text-base text-gray-500 pb-8">
                                        Their strategy of manually reaching out to customers and prospects led to an overload of information that demanded careful
                                        cross-verification. They had to verify data manually to avoid asking repetitive questions to their clients - a vital but monotonous process
                                        that ate into their employees&apos; productivity.Such bureaucratic procedures slow down the daily operation and lead to longer customer
                                        waiting times, impacting customer satisfaction negatively.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div>
                            <h2 className="lg:text-4xl text-2xl  font-bold pb-10" style={{ color: "#4A5568" }}>
                                The Turning Point: Choosing Gallabox
                            </h2>
                            <div className=" space-y-8">
                                <p className="lg:text-lg text-base  text-gray-500">
                                    With these cumbersome procedures and numerous inefficient processes, it was clear ITEES needed a change. Casting around for a solution, they
                                    sought an innovative solution capable of streamlining their processes, saving them valuable time, and enhancing their customer relationships.
                                </p>
                                <p className="lg:text-lg text-base  text-gray-500">
                                    This triggered ITEES&apos; search for a robust solution to streamline their customer interaction process and reduce the burden of manual work —
                                    a journey that led them to Gallabox.
                                </p>
                                <div className="">
                                    <h3 className="text-2xl  text-gray-500 font-semibold pb-8">The Move from WATI</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        Choosing a suitable WhatsApp Business API provider was another challenge ITEES had to overcome. With their phone number constantly being
                                        blocked and limitations placed on the numbers that could be linked with an account, the inadequacies of their previous provider, WATI, were
                                        evident.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">Their long, arduous search led them to the savvy and supportive Gallabox team.</p>
                                </div>
                                <div className="">
                                    <h3 className="text-2xl  text-gray-500 font-semibold pb-8">Why Gallabox?</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        The transition, however, wasn&apos;t an out-of-the-blue decision.ITEES considered multiple WhatsApp Business API providers but ultimately
                                        chose Gallabox for its exceptional onboarding support and a unique set of features that set Gallabox apart in the realm of WhatsApp
                                        Automation.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        Their administrative and technical team found Gallabox an effective solution to their existing limitations and problems with the help of
                                        Gallabox&apos;s excellent onboarding support - something they didn&apos;t find in their previous provider, WATI.
                                    </p>
                                </div>
                                <div className="">
                                    <h3 className="text-2xl  text-gray-500 font-semibold pb-8">A Multifaceted Impact</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        The eye hospital optimised its operations by using Gallabox to increase review collection, improve customer engagement, and send booking
                                        confirmations and appointment reminders.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        The transition to Gallabox allowed the hospital to free up its service and success teams from the strenuous process of manually transferring
                                        data. Gallabox&apos;s integration with Odoo automated everything – from sending appointment reminders to the review collection process.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        This liberating transition primarily benefitted the hospital&apos;s &apos;front-office warriors&apos; – their customer-facing staff in
                                        administration and reception areas to focus on high-impact tasks.
                                    </p>
                                </div>
                                <div className="">
                                    <h3 className="text-2xl  text-gray-500 font-semibold pb-8">Empowering Frontline Warriors</h3>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        The shift to Gallabox was more than just a change of platform for ITEES. It brought them remarkable success in improving their Google
                                        ratings and feedback collection mechanism.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500 pb-8">
                                        Automating post-appointment interaction through Gallabox Chatbot drastically improved the hospital&apos;s rating. By freeing up their
                                        front-office staff and delivering exceptional service, they experienced a higher frequency of repeat customer visits and new customer
                                        footfall.
                                    </p>
                                </div>
                                <TestimonialSectionCaseStudy
                                    testimonialData={{
                                        headerTitle:
                                            "Using Gallabox for the post-visit feedback and ratings collection process, a task that involved a sizable effort with a low ROI. The benefits we reaped by switching to Gallabox were nothing short of impressive.",
                                        avatarImg: "https://assets.gallabox.com/gb-home/itees/owner.jpg",
                                        nameText: "Mohammed Udaif",
                                        professionText: "ITEES Eye Foundation",
                                    }}
                                />
                            </div>
                        </div>
                    </main>
                </div>
            </div>

            <section style={{ backgroundColor: "#FFED82" }} className="flex flex-col items-center justify-center">
                <div className="max-w-6xl mx-auto px-4 md:px-20 py-8">
                    <h4 className="font-bold lg:text-3xl text-base text-center text-yellow-800" style={{ fontSize: "26px" }}>
                        Save time and effort while delivering <br /> an exceptional customer experience!
                    </h4>
                    <div className="flex justify-center mt-4">
                        {" "}
                        <AppButton buttonText="Get Started" href="https://app.gallabox.com/signup" />
                    </div>
                </div>
            </section>

            <RelatedCaseStudies related={RELATED_CASE_STUDIES} />

            <style jsx>{`
                .itees-header {
                    background-color: #edfdfd;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    width: 100vw;
                    height: 500px;
                }
                .itees-header h1 {
                    font-family: Google Sans;
                    font-style: normal;
                    letter-spacing: 0.02em;
                    color: #162c6f;
                }
                .itees-header .top-text {
                    font-weight: 500;
                    font-size: 30px;
                    line-height: 38px;
                }
                .itees-header .bottom-text {
                    font-weight: 700;
                    font-size: 50px;
                    line-height: 64px;
                }
                .case-study-bluebox-slider {
                    font-family: "Google Sans";
                    font-style: normal;
                    letter-spacing: 0.05em;
                    color: #4a5568;
                    background-color: #ffffff;
                    box-shadow: 2.01005px 2.01005px 10.0503px rgba(51, 100, 250, 0.2), inset 0px 0px 10.0503px rgba(122, 152, 244, 0.1);
                    border-radius: 10.0503px;
                }
                .slider-profile-name {
                    font-weight: 700;
                    font-size: 22.1106px;
                    width: fit-content;
                    line-height: 28px;
                }
                .slider-content {
                    font-style: italic;
                    font-weight: 500;
                    font-size: 26.1307px;
                    line-height: 40px;
                    width: fit-content;
                }
                .slider-profile-about {
                    font-weight: 400;
                    font-size: 17.9834px;
                    line-height: 23px;
                    text-align: center;
                }
                .case-study-tag-filter {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14.9744px;
                    line-height: 19px;
                    letter-spacing: 0.02em;
                    color: #2d3748;
                }
                .case-study-filter-checkbox {
                    width: 18px;
                    height: 18px;
                    background-color: #ffffff;
                    border: 1.5px solid #0083ff;
                    border-radius: 2px;
                }
                .case-study-carousal {
                    border-radius: 10px;
                }
                .case-study-carousal-content {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 40px;
                    letter-spacing: 0.02em;
                    color: #ffffff;
                }
                .case-study-carousal .redirect {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 19px;
                    letter-spacing: 0.02em;
                    color: #bababa;
                }
                .case-study-carousal .redirect::after {
                    content: url("https://assets.gallabox.com/gb-home/case-study/redirect-arrow.png");
                    position: relative;
                    left: 4px;
                    top: 2px;
                }
                .carousal-img {
                    width: 530px;
                    background-color: #d9d9d9;
                    border-radius: 4.99649px;
                }
                .filter-title-case-study {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 500;
                    font-size: 15px;
                    line-height: 19px;
                    text-align: center;
                    letter-spacing: 0.02em;
                    color: #838383;
                }
                .slider-btn-right {
                    position: absolute;
                    top: 150px;
                    right: -35px;
                    z-index: 5;
                }
                .slider-btn-left {
                    position: absolute;
                    top: 150px;
                    left: -35px;
                    z-index: 5;
                }
                .slide-count-case-study {
                    width: 60px;
                    height: 60px;
                    color: #3364fa;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }
                .left-arrow {
                    width: 30px;
                    height: 30px;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }
                .right-arrow {
                    width: 30px;
                    height: 30px;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }

                @media (max-width: 35rem) {
                    .itees-header {
                        background-size: contain;
                        height: 100%;
                    }
                    .itees-header .top-text {
                        font-size: 20px;
                    }
                    .itees-header .bottom-text {
                        font-size: 30px;
                        padding-inline: 1rem;
                        line-height: 35px;
                        margin-top: 0.7rem;
                    }
                    .case-study-carousal {
                        border-radius: 10px;
                    }
                    .carousal-img {
                        width: 100%;
                    }
                    .case-study-carousal-content {
                        font-size: 18px;
                        line-height: 28px;
                        padding-inline: 1rem;
                        margin-top: 0.5rem;
                        margin-bottom: 1rem;
                    }
                    .slide-count-case-study {
                        width: 50px;
                        height: 50px;
                    }
                    .left-arrow {
                        width: 30px;
                        height: 30px;
                    }
                    .right-arrow {
                        width: 30px;
                        height: 30px;
                    }
                    .slider-profile-name {
                        font-size: 19px;
                        line-height: 30px;
                    }
                    .slider-profile-about {
                        font-size: 18px;
                        line-height: 23px;
                    }
                    .slider-content {
                        font-size: 16px;
                        line-height: 23px;
                    }
                    .slider-btn-right {
                        top: 180px;
                        right: -5px;
                        width: 3rem;
                    }
                    .slider-btn-left {
                        top: 180px;
                        left: -5px;
                        width: 3rem;
                    }
                }
            `}</style>
        </NewLayout>
    );
};

export default itees;
